import AlephBet from "alephbet"
import {storageAdapter, superPropertiesLamedAdapter} from "./adapters"
import {getUserId, onCheckoutPage} from "./helpers"
import {premiumSubscriptionStarted} from "./goals"
import $ from "cash-dom"
import React from "react"
import {createRoot} from "react-dom/client"
import FaIcon from "components/fa_icon"

export default () => {
  const moneyBackTextCloseToPurchaseButton = new AlephBet.Experiment({
    name: "202506 Money-back guarantee close to purchase button",
    /* eslint-disable camelcase */
    tracking_adapter: superPropertiesLamedAdapter,
    storage_adapter: storageAdapter,
    user_id: getUserId(),
    /* eslint-enable camelcase */
    trigger: () => onCheckoutPage(),
    variants: {
      "1-Original": {
        activate: () => {
        }
      },
      "2-Variant": {
        activate: (experiment) => {
          if (!experiment.options.trigger()) return

          const copy = {
            en: "100% money-back-guarantee",
            es: "Garantía de devolución del 100% de tu dinero",
            pt: "Garantia de 100% de reembolso",
            de: "100% Geld-zurück-Garantie",
            fr: "Garantie de remboursement à 100 %"
          }

          const renewalNotice1 = $(".renewal-notice").eq(0).find("strong")
          const originalText = renewalNotice1.text().trim()
          const cleanedText = originalText.replace(/^\*\s*/, "")
          const updatedText = renewalNotice1.get(0)

          const renewalNotice2 = $(".renewal-notice").eq(1).get(0)
          if (renewalNotice2) {
            renewalNotice2.prepend(
              document.createTextNode(cleanedText + " ")
            )
          } else {
            const newP = document.createElement("p")
            newP.className = "renewal-notice"
            newP.textContent = cleanedText
            updatedText.closest(".renewal-notice").after(newP)
          }
          const root = createRoot(updatedText)
          root.render(
            <>
              <FaIcon name="fa-check" textAligned />
              {" " + copy[window.gon.locale]}
            </>
          )

          $(updatedText).css("color", "#48C891")
        }
      }
    }
  })

  moneyBackTextCloseToPurchaseButton.add_goals([
    premiumSubscriptionStarted
  ])
}
